const UserData = [
  {
    id: 1,
    userTitle: "SELLER",
    description:
      '"I am here to Sell the credits i generated to save the earth"',
    src: "/images/seller-image.png",
  },
  {
    id: 2,
    userTitle: "BUYER",
    description: '"I am here to Buy the credits to save the earth"',
    src: "/images/buyer-image.png",
  },

  {
    id: 3,
    userTitle: "TRADER",
    description: '"I am here to Trade the credits to save the earth"',
    src: "/images/trader-image.png",
  },
];

export default UserData;
